module.exports = __webpack_public_path__ + "static/keysource-9ae89e7d61c50576016eeabbff41e8a5.png";